import React from 'react';
import PageFrame from './PageFrame';
import resolveTemplateHeader, { mergeFamilyHeaderChrome } from './resolveTemplateHeader';

/**
 * WorkspacePageTemplate — operational / form workspace floorplan.
 * Header → optional tabs → primary work surface (consumption forms, pick lists, …).
 * POS uses its own shell (POS-DESIGN-CONSTITUTION); this covers secondary ops pages.
 */
const WorkspacePageTemplate = ({
  children,
  className = '',
  dir,
  wide = false,
  header,
  familyHeader,
  title,
  subtitle,
  headerActions,
  tabs,
  toolbar,
  embedTabsInToolbar = true,
  content,
}) => {
  const inlineToolbarTabs =
    embedTabsInToolbar !== false && familyHeader && tabs ? tabs : undefined;
  const mergedFamilyHeader = mergeFamilyHeaderChrome(familyHeader, {
    toolbar,
    center: inlineToolbarTabs ?? familyHeader?.center,
  });
  const resolvedHeader = resolveTemplateHeader({
    header,
    familyHeader: mergedFamilyHeader,
    title,
    subtitle,
    headerActions,
  });

  return (
    <PageFrame
      className={['ads-screen-workspace', 'ads-screen-form', className].filter(Boolean).join(' ')}
      dir={dir}
      wide={wide}
    >
      {resolvedHeader}
      {tabs && (!familyHeader || embedTabsInToolbar === false) ? tabs : null}
      {toolbar && !familyHeader ? toolbar : null}
      {content ?? children}
    </PageFrame>
  );
};

export default WorkspacePageTemplate;
